var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.167,
    height: 23.167,
    viewBox: "0 0 23.167 23.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5529",
    "data-name": "Caminho 5529",
    d: "M16.265,0H6.9A6.909,6.909,0,0,0,0,6.9v9.364a6.909,6.909,0,0,0,6.9,6.9h9.364a6.909,6.909,0,0,0,6.9-6.9V6.9A6.909,6.909,0,0,0,16.265,0Zm4.571,16.265a4.571,4.571,0,0,1-4.571,4.571H6.9a4.571,4.571,0,0,1-4.571-4.571V6.9A4.571,4.571,0,0,1,6.9,2.331h9.364A4.571,4.571,0,0,1,20.836,6.9v9.364Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5530",
    "data-name": "Caminho 5530",
    d: "M138.992,133a5.992,5.992,0,1,0,5.992,5.992A6,6,0,0,0,138.992,133Zm0,9.653a3.661,3.661,0,1,1,3.661-3.661A3.661,3.661,0,0,1,138.992,142.653Z",
    transform: "translate(-127.408 -127.408)",
    fill: "#909090"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 1.436,
    cy: 1.436,
    r: 1.436,
    transform: "translate(16.151 4.201)",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8267756c3bc86d9528748967f962a67a.svg";
export { ForwardRef as ReactComponent };